export default {
  title: 'Pay with Pix',
  hint: 'Copy the code and paste it into Pix in your bank app, or scan the QR code with it.',
  copy: 'Copy Pix code',
  copied: 'Code copied',
  qr_alt: 'Pix QR code',
  expires_in: 'The code expires in {{time}}',
  waiting: 'We’ll confirm your order as soon as your bank sends the payment.',
  open_page: 'Open the payment page instead',
  expired: 'This Pix code has expired. Start the payment again to get a new one.',
  cancel: 'Cancel payment',
  checking: 'Checking your payment…',
  close: 'Close',
};
